import { render, staticRenderFns } from "./trafficdetail.vue?vue&type=template&id=b171526e&scoped=true&"
import script from "./trafficdetail.vue?vue&type=script&lang=js&"
export * from "./trafficdetail.vue?vue&type=script&lang=js&"
import style0 from "./trafficdetail.vue?vue&type=style&index=0&id=b171526e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b171526e",
  null
  
)

export default component.exports